import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { uploadBillCall } from "../redux/slice/uploadBill";

import Spinner from "./spinner/Spinner";
import uparrow from "../assets/images/uparrow.svg";

const MyVerticallyCenteredModal = forwardRef((props, ref) => {
  // const { mobile } = useContext(AppContext);
  const {
    setModalShow,
    setFailModalShow,
    setFailMessage,
    setSuccessModalShow,
    setSuccessModal2Show,
    setSuccessMessage,
  } = props;
  const mobile = localStorage.getItem("mobile");

  const dispatch = useDispatch();
  const [imageObject, setImageObject] = useState({
    uploadedFile: null,
    previewMode: false,
    fileUrl: null,
    base64: "",
    extension: "",
    error: false,
  });
  const { uploadBillData, loading, success } = useSelector(
    (state) => state.uploadBill
  );
  const maxSize = 5 * 1024 * 1024;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      //   setExtension(file?.type?.split("/")[1]);
      //   setUploadedFile(file);
      //   setPreviewMode(false);
      //   setFileUrl(URL.createObjectURL(file));

      setImageObject((pre) => {
        let obj = {
          ...pre,
          extension: file?.type?.split("/")[1],
          uploadedFile: file,
          fileUrl: URL.createObjectURL(file),
          previewMode: false,
        };

        return obj;
      });

      if (file?.size > maxSize) {
        setImageObject((pre) => {
          return { ...pre, error: true };
        });
      } else {
        setImageObject((pre) => {
          return { ...pre, error: false };
        });
      }
      // converting image to Base 64 logic
      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert to Base64

      reader.onload = () => {
        // setBase64(reader.result); // Set the Base64 string

        setImageObject((pre) => {
          let obj = {
            ...pre,
            base64: reader.result,
          };
          return obj;
        });
      };

      reader.onerror = (error) => {
        console.error("Error converting to Base64:", error);
      };
    }
  };

  const handleNext = () => {
    if (imageObject?.uploadedFile) {
      setImageObject((pre) => {
        let obj = {
          ...pre,
          previewMode: true,
        };

        return obj;
      });
    }
  };

  const handleReset = () => {
    setImageObject({
      uploadedFile: null,
      previewMode: false,
      fileUrl: null,
      base64: "",
      extension: "",
    });
  };

  useImperativeHandle(ref, () => ({
    handleReset,
  }));

  const handleSubmit = async () => {
    const data = {
      body: {
        identifierType: "mobile",
        identifierValue: mobile,
        fileExtension: `.${imageObject?.extension}`,
        imageData: imageObject?.base64,
      },
    };

    const result = await dispatch(uploadBillCall(data));

    let text =
      "Your bill has been successfully uploaded we will let you know once its processed";
    if (
      result?.payload?.hasOwnProperty("response") &&
      result?.payload?.response[0]?.errors?.length > 0
    ) {
      setFailModalShow(true);
      setFailMessage(result?.payload.response[0]?.errors[0]?.message);
    } else if (
      result?.payload?.hasOwnProperty("message") &&
      result?.payload?.message?.length > 0 &&
      result?.payload?.message ===
        "image is under processing.Please check the status on micro-site."
    ) {
      setSuccessModalShow(true);
      setSuccessMessage(text);
    } else if (
      result?.payload?.hasOwnProperty("message") &&
      result?.payload?.message?.length > 0 &&
      result?.payload?.message === "image_processing"
    ) {
      setSuccessModalShow(true);
      setSuccessMessage(text);
    } else if (
      result?.payload?.hasOwnProperty("message") &&
      result?.payload?.message?.length > 0
    ) {
      const messageOrPoints = extractErrorMessageOrPoints(result?.payload);
      if (typeof messageOrPoints === "number") {
        setSuccessModal2Show(true);
        setSuccessMessage(messageOrPoints);
      } else {
        if (messageOrPoints === "Vendor GST-IN not recognized") {
          setSuccessMessage(
            "Your bill is under processed. Our team will verify the bill and your profile will be updated accordingly"
          );
          setSuccessModalShow(true);
        } else if (
          messageOrPoints === "manual receipt correction is required"
        ) {
          setSuccessMessage(
            "Thanks for submitting the bill. You'll get points if the bill gets approved. Please keep the bill until then."
          );
          setSuccessModalShow(true);
        } else if (messageOrPoints?.includes("Vendor GST-IN not recognized")) {
          setSuccessMessage(
            "Thanks for submitting the bill. You’ll get the points if the bill gets approved. Please keep the bill until then."
          );
          setSuccessModalShow(true);
        } else {
          setFailMessage(messageOrPoints);
          setFailModalShow(true);
        }
      }
    }
    setModalShow(false);
  };

  function extractErrorMessageOrPoints(response) {
    const { message } = response;

    try {
      // Attempt to parse the message string
      const parsedMessage = JSON.parse(message);

      // If parsed successfully, check the structure
      if (parsedMessage.response && Array.isArray(parsedMessage.response)) {
        const responseItem = parsedMessage.response[0];

        // Check if there are any errors
        if (responseItem.errors && responseItem.errors.length > 0) {
          return responseItem.errors[0].message; // Return the first error's message
        }

        // Check for sideEffects
        const sideEffects = responseItem.result?.sideEffects;
        if (Array.isArray(sideEffects) && sideEffects.length > 0) {
          const points = Number(sideEffects[0]?.awardedPoints);
          if (!isNaN(points)) {
            return points; // Return awardedPoints as a number if available
          }
        } else if (sideEffects === null || sideEffects?.length === 0) {
          return "Bill upload failed"; // Return "Bill upload failed" if sideEffects is null
        } else {
          return "Bill upload failed";
        }
      }
    } catch (e) {
      // If parsing fails, assume it's a plain string and return it
    }

    return message; // Return the plain message if parsing or extraction fails
  }

  useEffect(() => {
    return () => {
      if (imageObject?.fileUrl) {
        URL.revokeObjectURL(imageObject?.fileUrl);
      }
    };
  }, [imageObject?.fileUrl]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    // Check screen size on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={!isMobile}
        className="conditional-modal slide-up-modal upload"
      >
        <button
          type="button"
          className="custom-close"
          aria-label="Close"
          onClick={() => {
            props.onHide();
            handleReset();
          }}
          style={{ top: "-10%", left: "-33px" }}
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center w-100"
          >
            {imageObject?.previewMode ? "Bill Preview" : "Upload your Bill"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-2">
          {
            <>
              {imageObject?.previewMode ? (
                <div>
                  {imageObject?.uploadedFile.type.includes("image") ? (
                    <img
                      src={imageObject?.fileUrl}
                      alt="Uploaded file preview"
                      style={{ width: "100%", height: "auto" }}
                    />
                  ) : (
                    <p>File format not supported for preview.</p>
                  )}
                </div>
              ) : (
                <>
                  <div className="file-upload-box">
                    {/* Hidden file input */}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      id="fileInput"
                      style={{ display: "none" }}
                    />
                    {/* Clickable image */}
                    <img
                      src={uparrow}
                      alt="Click to upload"
                      className="upload-image"
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    />

                    {imageObject?.uploadedFile && (
                      <p>Selected File: {imageObject?.uploadedFile.name}</p>
                    )}
                    <p className="dragtext">Drag or click here to upload</p>
                  </div>
                  <div>
                    <p className="error-text">
                      {imageObject?.error
                        ? "File should be less than 5 mb"
                        : null}
                    </p>
                  </div>
                </>
              )}
            </>
          }
        </Modal.Body>

        <Modal.Footer>
          {imageObject?.previewMode ? (
            <Button
              onClick={handleSubmit}
              style={{ display: "flex" }}
              disabled={loading}
            >
              Submit Bill {loading ? <Spinner /> : null}
            </Button>
          ) : (
            <Modal.Footer>
              <Button
                onClick={handleNext}
                disabled={!imageObject?.uploadedFile || imageObject?.error}
              >
                Next
              </Button>
            </Modal.Footer>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
});

export default MyVerticallyCenteredModal;
